import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { IApplicationState } from 'components/store/types'
import { AppDispatch } from 'components/store/state/store'
import { updateActiveView } from 'components/core/state/actions'
import { getActiveView } from 'components/core/state/selectors'
import Button from '@mui/material/Button'
import { css, StyleSheet } from 'aphrodite'
import constants from 'utils/constants'
import { AvailableView } from 'components/core/types'

const mapState = (state: IApplicationState) => ({
  activeView: getActiveView(state),
})
const mapDispatch = (dispatch: AppDispatch) => ({
  switchView: (newActiveView) => dispatch(updateActiveView(newActiveView)),
})
const connector = connect(mapState, mapDispatch)

interface CliniquesSwitcherButtonProps extends ConnectedProps<typeof connector> {
  buttonView: AvailableView,
  icon: string
}

const CliniquesSwitcherButton = ({
  activeView,
  buttonView,
  icon,
  switchView,
}: CliniquesSwitcherButtonProps) => {
  const activeButtonStyles = css(styles.button)
  const inactiveButtonStyles = css(styles.button, styles.inactiveButton)

  const handleSwitch = (newView) => {
    if (activeView === newView) {
      return
    }
    switchView(newView)
  }

  return (
    <Button
      className={activeView === buttonView ? activeButtonStyles : inactiveButtonStyles}
      onClick={() => handleSwitch(buttonView)}
    >
      <img className="tw-w-full tw-h-full" src={icon} alt="" />
    </Button>
  )
}
const styles = StyleSheet.create({
  button: {
    backgroundColor: constants.colors.green,
    borderColor: constants.colors.green,
    minHeight: 38,
    minWidth: 38,
    marginLeft: 3,
    padding: '5px 15px',
  },
  inactiveButton: {
    opacity: 0.5,
  },
})
export default connector(CliniquesSwitcherButton)
